import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["thread", "input"]

  connect() {
    this.scrollToBottom()
  }

  scrollToBottom() {
    if (this.hasThreadTarget) {
      this.threadTarget.scrollTop = this.threadTarget.scrollHeight
    }
  }

  autoResize(event) {
    const textarea = event.target
    textarea.style.height = 'auto'
    textarea.style.height = Math.min(textarea.scrollHeight, 150) + 'px'
  }

  submitOnEnter(event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      event.target.closest('form').requestSubmit()
    }
  }

  clearInput(event) {
    if (this.hasInputTarget && event.detail.success) {
      this.inputTarget.value = ''
      this.inputTarget.style.height = 'auto'
      // Scroll to bottom after new message is added
      setTimeout(() => this.scrollToBottom(), 100)
    }
  }
}
